/* Casa Vici Living theme behaviour. No dependencies. */
(function () {
  'use strict';
  var C = window.casa || { routes: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); };

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('.drawer__panel button, .drawer__panel a, .drawer__panel input');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(document.getElementById(o.getAttribute('data-drawer-open'))); return; }
    var c = e.target.closest('[data-drawer-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Search toggle ---------- */
  var st = $('[data-search-toggle]');
  if (st) st.addEventListener('click', function () {
    var bar = document.getElementById('HeaderSearch');
    if (!bar) return;
    var show = bar.hasAttribute('hidden');
    if (show) { bar.removeAttribute('hidden'); var i = bar.querySelector('input[type=search]'); if (i) i.focus(); }
    else bar.setAttribute('hidden', '');
    st.setAttribute('aria-expanded', show ? 'true' : 'false');
  });

  /* ---------- Announcement rotator (mobile shows one at a time) ---------- */
  var ann = $('[data-announce]');
  if (ann) {
    var items = $$('.announce__item', ann);
    if (items.length > 1) {
      var ai = 0;
      setInterval(function () {
        items[ai].classList.remove('is-active');
        ai = (ai + 1) % items.length;
        items[ai].classList.add('is-active');
      }, 4500);
    }
  }

  /* ---------- Toast ---------- */
  var toastEl = $('[data-toast]'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Cart ---------- */
  var drawerEnabled = !!$('[data-cart-drawer]');
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function renderDrawer(html) {
    var old = $('[data-cart-drawer]');
    if (!old || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer] .drawer__panel');
    var panel = old.querySelector('.drawer__panel');
    if (fresh && panel) panel.innerHTML = fresh.innerHTML;
  }
  function refreshCount() {
    return fetch((C.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }
  function afterChange(sections) {
    if (sections && sections['cart-drawer']) renderDrawer(sections['cart-drawer']);
    return refreshCount();
  }
  function addToCart(id, qty, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var body = { items: [{ id: Number(id), quantity: qty || 1 }] };
    if (drawerEnabled) body.sections = 'cart-drawer';
    return fetch(C.routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add this piece.');
        if (!drawerEnabled) { window.location.href = C.routes.cart || '/cart'; return; }
        return afterChange(res.d.sections).then(function () { openDrawer($('[data-cart-drawer]')); });
      })
      .catch(function (err) { toast(err.message); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }
  function changeLine(key, qty) {
    var body = { id: key, quantity: Math.max(0, qty) };
    if (drawerEnabled) body.sections = 'cart-drawer';
    var panel = $('[data-cart-drawer] .drawer__panel');
    if (panel) panel.style.opacity = '0.6';
    return fetch(C.routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not update the cart.');
        return afterChange(res.d.sections);
      })
      .catch(function (err) { toast(err.message); })
      .then(function () { if (panel) panel.style.opacity = ''; });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && drawerEnabled) { e.preventDefault(); openDrawer($('[data-cart-drawer]')); return; }
    var lq = e.target.closest('[data-line-qty]');
    if (lq) { e.preventDefault(); changeLine(lq.getAttribute('data-line-qty'), parseInt(lq.getAttribute('data-qty-to'), 10)); return; }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addToCart(qa.getAttribute('data-quick-add'), 1, qa); return; }
    var cs = e.target.closest('[data-cart-step]');
    if (cs) {
      var inp = document.getElementById(cs.getAttribute('data-target'));
      if (inp) {
        inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(cs.getAttribute('data-cart-step'), 10));
        var form = inp.form;
        if (form) { var u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1'; form.appendChild(u); form.submit(); }
      }
    }
  });
  document.addEventListener('change', function (e) {
    var li = e.target.closest('[data-line-input]');
    if (li) { changeLine(li.getAttribute('data-line-input'), parseInt(li.value, 10) || 0); return; }
    var ci = e.target.closest('[data-cart-input]');
    if (ci && ci.form) { var u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1'; ci.form.appendChild(u); ci.form.submit(); }
  });

  /* ---------- Product page ---------- */
  var sec = $('[data-product-section]');
  if (sec) initProduct(sec);

  function initProduct(sec) {
    var form = $('[data-product-form]', sec);
    var jsonEl = $('[data-product-json]', sec);
    var data = { variants: [] };
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { /* keep defaults */ }
    var idInput = $('[data-variant-id]', sec);
    var addBtn = $('[data-add-btn]', sec);
    var addLabel = $('[data-add-label]', sec);
    var stickyAdd = $('[data-sticky-add]', sec);
    var slides = $('[data-slides]', sec);
    var slideEls = $$('[data-slide]', sec);
    var thumbs = $$('[data-thumb]', sec);
    var dots = $$('.pdp__dots span', sec);

    function current() {
      var id = Number(idInput && idInput.value);
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return data.variants[0];
    }

    /* Gallery */
    function goTo(i, smooth) {
      if (!slides || !slideEls[i]) return;
      slides.scrollTo({ left: slideEls[i].offsetLeft - slides.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function activeIndex() {
      if (!slides) return 0;
      var w = slides.clientWidth || 1;
      return Math.round(slides.scrollLeft / w);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    var prev = $('[data-slide-prev]', sec), next = $('[data-slide-next]', sec);
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(slideEls.length - 1, activeIndex() + 1)); });
    if (slides) {
      var sT;
      slides.addEventListener('scroll', function () { clearTimeout(sT); sT = setTimeout(function () { mark(activeIndex()); }, 60); }, { passive: true });
    }

    /* Variants */
    function selected() {
      var opts = [];
      $$('[data-opt]', sec).forEach(function (r) { if (r.checked) opts[Number(r.getAttribute('data-opt'))] = r.value; });
      return opts;
    }
    function update(v) {
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      var p = $('[data-price]', sec); if (p) p.textContent = money(v.price);
      var sp = $('[data-sticky-price]', sec); if (sp) sp.textContent = money(v.price);
      var cmp = $('[data-compare]', sec);
      var save = $('[data-save]', sec);
      if (cmp) {
        if (v.compare > v.price) { cmp.textContent = money(v.compare); cmp.removeAttribute('hidden'); }
        else cmp.setAttribute('hidden', '');
      }
      if (save) {
        if (v.compare > v.price) { save.textContent = 'Save ' + money(v.compare - v.price); save.removeAttribute('hidden'); }
        else save.setAttribute('hidden', '');
      }
      var label = v.available ? 'Add to cart' : 'Sold out';
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = label;
      if (stickyAdd) { stickyAdd.disabled = !v.available; stickyAdd.textContent = label; }
      var stock = $('[data-stock]', sec);
      if (stock) stock.classList.toggle('is-out', !v.available);
      if (v.media) {
        for (var i = 0; i < slideEls.length; i++) {
          if (Number(slideEls[i].getAttribute('data-media-id')) === v.media) { goTo(i); break; }
        }
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-opt]', sec).forEach(function (r) {
      r.addEventListener('change', function () {
        var opts = selected();
        var lbl = $('[data-opt-value="' + r.getAttribute('data-opt') + '"]', sec);
        if (lbl) lbl.textContent = r.value;
        var match = null;
        for (var i = 0; i < data.variants.length; i++) {
          var vo = data.variants[i].options, ok = true;
          for (var k = 0; k < opts.length; k++) if (opts[k] !== undefined && vo[k] !== opts[k]) { ok = false; break; }
          if (ok) { match = data.variants[i]; break; }
        }
        update(match);
      });
    });

    /* Quantity */
    var qty = $('[data-qty]', sec);
    $$('[data-qty-step]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
        qty.value = Math.min(20, Math.max(1, n));
      });
    });

    /* Add to cart */
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = current();
      if (!v || !v.available) return;
      addToCart(v.id, parseInt(qty && qty.value, 10) || 1, addBtn);
    });
    if (stickyAdd) stickyAdd.addEventListener('click', function () {
      var v = current();
      if (v && v.available) addToCart(v.id, parseInt(qty && qty.value, 10) || 1, stickyAdd);
    });

    /* Sticky bar shows once the main button scrolls out of view */
    var sticky = $('[data-sticky-atc]', sec);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', out);
        sticky.setAttribute('aria-hidden', out ? 'false' : 'true');
      }).observe(addBtn);
    }
  }

  /* ---------- Collection sort ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Drop empty filter inputs so URLs stay clean */
  var ff = $('[data-filter-form]');
  if (ff) ff.addEventListener('submit', function () {
    $$('input', ff).forEach(function (i) { if ((i.type === 'number' || i.type === 'hidden') && i.value === '') i.disabled = true; });
  });

  /* ---------- Recommendations ---------- */
  var recs = $('[data-recs]');
  if (recs && recs.getAttribute('data-url')) {
    fetch(recs.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelector('[data-recs-items]');
        var target = $('[data-recs-items]', recs);
        if (items && target && items.children.length > 0) target.innerHTML = items.innerHTML;
      })
      .catch(function () { /* server-rendered fallback stays */ });
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
})();
